import React, { useEffect, useState } from "react";
import { Tabs } from "antd";
import Cookies from "js-cookie";
import moment from "moment";
import qs from "qs";

import {
  AxiosCustomGet,
  AxiosCustomPut,
} from "../../../components/axios/AxiosCustom";
import Config from "../../../components/axios/Config";
import Breadcrumb from "../../../components/common/Breadcrumb/Breadcrumb";
import Title from "../../../components/common/Title/Title";
import ChooseOutletDialog from "../../finance/components/ChooseOutletDialog";
import TopupDeposit from "./components/TopUpDeposit";
import ImmediateTopup from "./components/ImmediateTopup";
import ConfirmDialog from "../../../components/common/ConfirmDialog/ConfirmDialog";
import RejectDialog from "../../../components/common/RejectDialog/RejectDialog";
import SwalToast from "../../../components/helpers/SwalToast";

import { convertOutletList } from "../../finance/helpers";
import { convertTopUpDeposit } from "./helpers/convertTopUpDeposit";
import { convertImmediateTopUp } from "./helpers/convertImmediateTopUp";

import {
  ACCEPT_DEPOSIT,
  CANCEL_TOPUP_DEPOSIT,
  IMMEDIATE_TOPUP_TYPE,
  initImmediateTopupFilterInput,
  initRequestType,
  initTopupDepositFilterInput,
  REJECT_DEPOSIT,
  SEND_IMMEDIATE_TOPUP,
  SEND_TOPUP,
  TOPUP_DEPOSIT_TYPE,
} from "./constants";

const TabPane = Tabs.TabPane;

const TopupDepositPage = () => {
  const [topupDepositTablePagination, setTopupDepositTablePagination] =
    useState({});
  const [topupDepositOutletCheckedList, setTopupDepositOutletCheckedList] =
    useState([]);
  const [topupDepositIndeterminate, setTopupDepositIndeterminate] =
    useState(false);
  const [topupDepositOutletCheckAll, setTopupDepositOutletCheckAll] =
    useState(false);
  const [topupDepositRequestTypeValue, setTopupDepositRequestTypeValue] =
    useState(initRequestType);
  const [topupDepositPageSize, setTopupDepositPageSize] = useState(10);
  const [topupDepositFilterInput, setTopupDepositFilterInput] = useState(
    initTopupDepositFilterInput
  );
  const [topupDepositList, setTopupDepositList] = useState([]);

  const [immediateTopupTablePagination, setImmediateTopupTablePagination] =
    useState({});
  const [immediateTopupOutletCheckedList, setImmediateTopupOutletCheckedList] =
    useState([]);
  const [immediateTopupIndeterminate, setImmediateTopupIndeterminate] =
    useState(false);
  const [immediateTopupOutletCheckAll, setImmediateTopupOutletCheckAll] =
    useState(false);
  const [immediateTopupDateValue, setImmediateTopupDateValue] = useState([]);
  const [immediateTopupPageSize, setImmediateTopupPageSize] = useState(10);
  const [immediateTopupFilterInput, setImmediateTopupFilterInput] = useState(
    initImmediateTopupFilterInput
  );
  const [immediateTopupList, setImmediateTopupList] = useState([]);

  const [tabState, setTabState] = useState(TOPUP_DEPOSIT_TYPE);
  const [loading, setLoading] = useState(false);
  const [outletList, setOutletList] = useState([]);
  const [isOutletDialogOpen, setIsOutletDialogOpen] = useState(false);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [isRejectDialogOpen, setIsRejectDialogOpen] = useState(false);
  const [confirmDialogState, setConfirmDialogState] = useState("");
  const [confirmDialogData, setConfirmDialogData] = useState({});
  const [selectedID, setSelectedID] = useState("");
  const [errors, setErrors] = useState({});
  const [reason, setReason] = useState("");

  const getOutlet = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}outlet/all`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setOutletList(convertOutletList(response.data.data));

        const outletListId = response.data.data.map((outlet) => {
          return outlet.id;
        });

        setTopupDepositOutletCheckedList(outletListId);
        setTopupDepositIndeterminate(false);
        setTopupDepositOutletCheckAll(true);

        setImmediateTopupOutletCheckedList(outletListId);
        setImmediateTopupIndeterminate(false);
        setImmediateTopupOutletCheckAll(true);
      }
    );
  };

  const getTopupDepositList = () => {
    setLoading(true);
    const data = {
      outlet_id_list: topupDepositFilterInput.outlets,
      request_type: topupDepositFilterInput.requestType,
      page: parseInt(topupDepositFilterInput.page),
      size: parseInt(topupDepositFilterInput.pageSize),
      sorting_field: topupDepositFilterInput.sortingField,
      sorting_order: topupDepositFilterInput.sortingOrder,
    };

    let url = `${process.env.REACT_APP_BASE_API_URL}topup/regular`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        data,
        (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        }
      ),
      (response) => {
        setLoading(false);
        setTopupDepositList(convertTopUpDeposit(response.data.data.items));
        setTopupDepositTablePagination({
          current: response.data.data.page,
          pageSize: response.data.data.per_page,
          total: response.data.data.total_item,
        });
      }
    );
  };

  const getImmediateTopupList = () => {
    setLoading(true);
    const data = {
      outlet_id_list: immediateTopupFilterInput.outlets,
      date_start: immediateTopupFilterInput.requestStartDate,
      date_end: immediateTopupFilterInput.requestEndDate,
      page: parseInt(immediateTopupFilterInput.page),
      size: parseInt(immediateTopupFilterInput.pageSize),
      sorting_field: immediateTopupFilterInput.sortingField,
      sorting_order: immediateTopupFilterInput.sortingOrder,
    };

    let url = `${process.env.REACT_APP_BASE_API_URL}topup/immediate`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        data,
        (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        }
      ),
      (response) => {
        setLoading(false);
        setImmediateTopupList(convertImmediateTopUp(response.data.data.items));
        setImmediateTopupTablePagination({
          current: response.data.data.page,
          pageSize: response.data.data.per_page,
          total: response.data.data.total_item,
        });
      }
    );
  };

  const handleSingleOutletChange = (list) => {
    if (tabState === TOPUP_DEPOSIT_TYPE) {
      setTopupDepositOutletCheckedList(list);
      setTopupDepositIndeterminate(
        !!list.length && list.length < outletList.length
      );
      setTopupDepositOutletCheckAll(list.length === outletList.length);
    } else {
      setImmediateTopupOutletCheckedList(list);
      setImmediateTopupIndeterminate(
        !!list.length && list.length < outletList.length
      );
      setImmediateTopupOutletCheckAll(list.length === outletList.length);
    }
  };

  const handleOutletCheckAllChange = (event) => {
    const outletListId = outletList.map((outlet) => {
      return outlet.value;
    });

    if (tabState === TOPUP_DEPOSIT_TYPE) {
      setTopupDepositOutletCheckedList(
        event.target.checked ? outletListId : []
      );
      setTopupDepositIndeterminate(false);
      setTopupDepositOutletCheckAll(event.target.checked);
    } else {
      setImmediateTopupOutletCheckedList(
        event.target.checked ? outletListId : []
      );
      setImmediateTopupIndeterminate(false);
      setImmediateTopupOutletCheckAll(event.target.checked);
    }
  };

  const handleOutletButtonClick = () => {
    setIsOutletDialogOpen(true);
  };

  const handleOutletSave = () => {
    if (tabState === TOPUP_DEPOSIT_TYPE) {
      setTopupDepositFilterInput((prev) => ({
        ...prev,
        outlets: topupDepositOutletCheckedList,
        page: 1,
      }));
    } else {
      setImmediateTopupFilterInput((prev) => ({
        ...prev,
        outlets: immediateTopupOutletCheckedList,
        page: 1,
      }));
    }
    setIsOutletDialogOpen(false);
  };

  const handleCancel = () => {
    setIsOutletDialogOpen(false);
    setIsConfirmDialogOpen(false);
    setIsRejectDialogOpen(false);

    if (errors.reason) {
      setErrors({});
    }
  };

  const handleTabChange = (key) => {
    setTabState(key);
  };

  const handleTextInputChange = (event) => {
    const { name, value } = event.target;

    if (name === "reason") {
      setReason(value);

      if (errors.reason) {
        setErrors({});
      }
      return;
    }

    if (tabState === TOPUP_DEPOSIT_TYPE) {
      setTopupDepositPageSize(value);
    } else if (tabState === IMMEDIATE_TOPUP_TYPE) {
      setImmediateTopupPageSize(value);
    }
  };

  const handleEnter =
    (type = "enter") =>
    (event) => {
      const { name, value } = event.target;
      if (event.keyCode === 13 || type === "blur") {
        if (tabState === TOPUP_DEPOSIT_TYPE) {
          if (value === "") {
            setTopupDepositPageSize(10);
          }
          setTopupDepositFilterInput((prev) => ({
            ...prev,
            [name]: value === "" ? 10 : value,
            page: 1,
          }));
        } else {
          if (value === "") {
            setImmediateTopupPageSize(10);
          }
          setImmediateTopupFilterInput((prev) => ({
            ...prev,
            [name]: value === "" ? 10 : value,
            page: 1,
          }));
        }
      }
    };

  const handleSelectChange = (field, data) => {
    if (field === "requestType") {
      setTopupDepositRequestTypeValue({
        value: data.value,
        label: data.label,
      });
      setTopupDepositFilterInput((prev) => ({
        ...prev,
        [field]: data.value,
        page: 1,
      }));
    }
  };

  const handleDateChange = (event) => {
    const startDate = moment(event?.[0]?._d).startOf("day");
    const endDate = moment(event?.[1]?._d).startOf("day");

    setImmediateTopupDateValue(event ? [startDate, endDate] : null);
    setImmediateTopupFilterInput((prev) => ({
      ...prev,
      requestStartDate: event ? new Date(startDate) : null,
      requestEndDate: event ? new Date(endDate) : null,
      page: 1,
    }));
  };

  const handleTableChange = (pagination, _, sorter) => {
    if (tabState === TOPUP_DEPOSIT_TYPE) {
      setTopupDepositFilterInput((prev) => ({
        ...prev,
        page: pagination.current,
        pageSize: parseInt(pagination.pageSize),
        sortingField: sorter?.column?.backend_key || null,
        sortingOrder:
          sorter?.order === "ascend"
            ? "ASC"
            : sorter?.order === "descend"
            ? "DESC"
            : null,
      }));
    } else {
      setImmediateTopupFilterInput((prev) => ({
        ...prev,
        page: pagination.current,
        pageSize: parseInt(pagination.pageSize),
        sortingField: sorter?.column?.backend_key || null,
        sortingOrder:
          sorter?.order === "ascend"
            ? "ASC"
            : sorter?.order === "descend"
            ? "DESC"
            : null,
      }));
    }
  };

  const handleSetConfirmDialogData = (dialogState, data) => {
    setConfirmDialogState(dialogState);
    setConfirmDialogData(data);

    if (
      dialogState === CANCEL_TOPUP_DEPOSIT ||
      dialogState === REJECT_DEPOSIT
    ) {
      setIsRejectDialogOpen(true);
    } else {
      setIsConfirmDialogOpen(true);
    }
  };

  const handleSendTopupButtonClick = (topupID) => {
    setSelectedID(topupID);

    const data = {
      actionButtonText: "Yakin",
      hasCancel: true,
      isDangerButton: false,
      title: "Anda Yakin Sudah Mengirim Top Up?",
      contentText: "Konfirmasi kembali transaksi anda sebelum melanjutkan.",
    };

    handleSetConfirmDialogData(SEND_TOPUP, data);
  };

  const handleSendImmediateTopupButtonClick = (topupID) => {
    setSelectedID(topupID);

    const data = {
      actionButtonText: "Yakin",
      hasCancel: true,
      isDangerButton: false,
      title: "Anda Yakin Sudah Mengirim Top Up?",
      contentText: "Konfirmasi kembali transaksi anda sebelum melanjutkan.",
    };

    handleSetConfirmDialogData(SEND_IMMEDIATE_TOPUP, data);
  };

  const handleAcceptDepositButtonClick = (depositID) => {
    setSelectedID(depositID);

    const data = {
      actionButtonText: "Yakin",
      hasCancel: true,
      isDangerButton: false,
      title: "Anda Yakin Sudah Menerima Setor Modal?",
      contentText: "Konfirmasi kembali penerimaan setor modal.",
    };

    handleSetConfirmDialogData(ACCEPT_DEPOSIT, data);
  };

  const handleCancelTopupDepositButtonClick = (ID) => {
    setSelectedID(ID);

    const data = {
      actionButtonText: "Batalkan",
      hasCancel: true,
      isDangerButton: true,
      title: "Batalkan Permohonan",
    };

    handleSetConfirmDialogData(CANCEL_TOPUP_DEPOSIT, data);
  };

  const handleCancelImmediateTopupButtonClick = (topupID) => {
    setSelectedID(topupID);

    const data = {
      actionButtonText: "Tolak",
      hasCancel: true,
      isDangerButton: true,
      title: "Tolak Permohonan",
    };

    handleSetConfirmDialogData(REJECT_DEPOSIT, data);
  };

  const validate = () => {
    const newErrors = {};

    if (!reason || reason === "") {
      newErrors.reason = "Alasan tidak boleh kosong";
    }
    return newErrors;
  };

  const handleConfirmDialogSave = () => {
    let url = "";
    let message = "";
    let data = null;

    if (
      confirmDialogState === SEND_TOPUP ||
      confirmDialogState === SEND_IMMEDIATE_TOPUP
    ) {
      url = `${process.env.REACT_APP_BASE_API_URL}topup/confirm-sent/${selectedID}`;
      message = "Sukses Mengirim Top Up";
    } else if (confirmDialogState === ACCEPT_DEPOSIT) {
      url = `${process.env.REACT_APP_BASE_API_URL}topup/confirm-received/${selectedID}`;
      message = "Sukses Menerima Setor Modal";
    } else if (
      confirmDialogState === CANCEL_TOPUP_DEPOSIT ||
      confirmDialogState === REJECT_DEPOSIT
    ) {
      const newErrors = validate();

      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        return;
      }

      url = `${process.env.REACT_APP_BASE_API_URL}topup/cancel/${selectedID}`;
      message = `Sukses ${
        confirmDialogState === CANCEL_TOPUP_DEPOSIT ? "Membatalkan" : "Menolak"
      } Permohonan`;
      data = {
        reason: reason,
      };
    }

    AxiosCustomPut(
      url,
      data || null,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      () => {
        SwalToast.fire({
          icon: "success",
          title: message,
        });
      },
      (error) => {
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: `Gagal: ${error.response.data.error.message}`,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      },
      () => {
        setIsConfirmDialogOpen(false);
        setIsRejectDialogOpen(false);
        setReason("");
        if (tabState === TOPUP_DEPOSIT_TYPE) {
          getTopupDepositList();
        } else {
          getImmediateTopupList();
        }
      }
    );
  };

  useEffect(() => {
    if (tabState === TOPUP_DEPOSIT_TYPE) {
      getTopupDepositList();
    } else {
      getImmediateTopupList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [topupDepositFilterInput, immediateTopupFilterInput, tabState]);

  useEffect(() => {
    getOutlet();
  }, []);

  return (
    <div>
      <div className="px-3">
        <div className="py-4 d-flex">
          <div className="d-flex flex-column" style={{ fontSize: "13px" }}>
            <Title text={"Permohonan Top Up & Setor Modal"} />
            <Breadcrumb current={"Permohonan Top Up & Setor Modal"} />
          </div>
        </div>
        <Tabs defaultActiveKey="topup_deposit" onChange={handleTabChange}>
          <TabPane tab="Top Up & Setor Rutin" key="topup_deposit">
            <TopupDeposit
              handleSendTopupButtonClick={handleSendTopupButtonClick}
              handleAcceptDepositButtonClick={handleAcceptDepositButtonClick}
              handleCancelTopupButtonClick={handleCancelTopupDepositButtonClick}
              data={topupDepositList}
              loading={loading}
              handleTableChange={handleTableChange}
              tablePagination={topupDepositTablePagination}
              handleEnter={handleEnter}
              pageSizeValue={topupDepositPageSize}
              handleOutletButtonClick={handleOutletButtonClick}
              handleSelectChange={handleSelectChange}
              handleInputChange={handleTextInputChange}
              selectedRequestType={topupDepositRequestTypeValue}
            />
          </TabPane>
          <TabPane tab="Immediate Top Up" key="immediate_topup">
            <ImmediateTopup
              handleSendTopupButtonClick={handleSendImmediateTopupButtonClick}
              handleCancelTopupButtonClick={
                handleCancelImmediateTopupButtonClick
              }
              data={immediateTopupList}
              loading={loading}
              handleTableChange={handleTableChange}
              tablePagination={immediateTopupTablePagination}
              handleEnter={handleEnter}
              pageSizeValue={immediateTopupPageSize}
              handleOutletButtonClick={handleOutletButtonClick}
              handleDateChange={handleDateChange}
              handleInputChange={handleTextInputChange}
              dateValue={immediateTopupDateValue}
            />
          </TabPane>
        </Tabs>

        <ChooseOutletDialog
          title={"Pilih Cabang/Outlet"}
          visible={isOutletDialogOpen}
          handleSave={handleOutletSave}
          handleCancel={handleCancel}
          data={outletList}
          onCheckAllChange={handleOutletCheckAllChange}
          onSingleChange={handleSingleOutletChange}
          indeterminate={
            tabState === TOPUP_DEPOSIT_TYPE
              ? topupDepositIndeterminate
              : immediateTopupIndeterminate
          }
          outletCheckAll={
            tabState === TOPUP_DEPOSIT_TYPE
              ? topupDepositOutletCheckAll
              : immediateTopupOutletCheckAll
          }
          outletCheckedList={
            tabState === TOPUP_DEPOSIT_TYPE
              ? topupDepositOutletCheckedList
              : immediateTopupOutletCheckedList
          }
        />

        <ConfirmDialog
          visible={isConfirmDialogOpen}
          handleCancel={handleCancel}
          handleSave={handleConfirmDialogSave}
          hasCancel={confirmDialogData.hasCancel}
          isDangerButton={confirmDialogData.isDangerButton}
          actionButtonText={confirmDialogData.actionButtonText}
          title={confirmDialogData.title}
          contentText={confirmDialogData.contentText}
        />

        <RejectDialog
          visible={isRejectDialogOpen}
          handleCancel={handleCancel}
          handleSave={handleConfirmDialogSave}
          hasCancel={confirmDialogData.hasCancel}
          isDangerButton={confirmDialogData.isDangerButton}
          actionButtonText={confirmDialogData.actionButtonText}
          title={confirmDialogData.title}
          handleChange={handleTextInputChange}
          errors={errors}
          reasonValue={reason}
        />
      </div>
    </div>
  );
};

export default TopupDepositPage;
